// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"34c9d2ca19dedb68aaf9","453":"ca198d796fea9ccc8b68"}[chunkId] + ".js";
};